var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "member-card",
    class: {
      'is-pending': _vm.isPending,
      'is-self': _vm.isSelf
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "member-info"
  }, [_c('h4', {
    staticClass: "member-name"
  }, [_vm._v(_vm._s(_vm.member.ptName))]), _c('span', {
    staticClass: "relationship-badge"
  }, [_vm._v(" " + _vm._s(_vm.member.relationship) + " ")])]), !_vm.isSelf ? _c('div', {
    staticClass: "authorization-status"
  }, [_c('span', {
    staticClass: "status-badge",
    class: _vm.statusClass
  }, [_vm._v(" " + _vm._s(_vm.statusText) + " ")])]) : _vm._e()]), _vm.showDetails ? _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("身分證字號")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.member.ptIdno))])]), _c('div', {
    staticClass: "info-row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("生日")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.member.ptBirthday))])])]) : _vm._e(), _vm.showActions ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-primary",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('edit', _vm.member);
      }
    }
  }, [_vm._v(" 編輯 ")]), _c('button', {
    staticClass: "btn btn-sm btn-outline-danger",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('delete', _vm.member);
      }
    }
  }, [_vm._v(" 刪除 ")])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }